// The hunt's Trainer tab on computers and tablets: eggs in the incubators with
// the time left on each. Phones keep the tab to the card, boosts and quests.
import { S, serverNow } from './state.ts';
import { EGG, EGG_UNLOCK_LEVEL, incubatorSlots } from '../shared/eggs.ts';
import { esc, full, left } from './fmt.ts';
import { patch } from './dom.ts';
import { GROUND, REGIONS } from '../shared/grounds.ts';
import { dexProgress } from '../shared/bestiary.ts';

export function renderEggSummary() {
  const host = document.getElementById('eggsum');
  const t = S.trainer;
  if (!host) return;
  const eggs = t?.eggs ?? [];
  if (!t || (t.level < EGG_UNLOCK_LEVEL && !eggs.length)) { if (!host.hidden) { patch(host, ''); host.hidden = true; } return; }
  host.hidden = false;
  const now = serverNow(), slots = incubatorSlots(t);
  const rows = [...eggs].sort((a, b) => a.hatchAt - b.hatchAt).map((e) => {
    const pct = Math.min(100, Math.max(0, ((now - e.start) / Math.max(1, e.hatchAt - e.start)) * 100));
    const name = EGG[e.egg]?.name ?? 'Egg';
    return `<div class="qs-row" title="${esc(name)}"><span class="ellip">${esc(name)} <span class="muted">${e.hatchAt > now ? left(e.hatchAt - now) : 'hatching'}</span></span><span class="bar thin"><i style="width:${pct}%"></i></span></div>`;
  }).join('');
  const free = Math.max(0, slots - eggs.length);
  patch(host, `<div class="qs-head"><b>Incubators</b><span class="muted">${full(eggs.length)} of ${full(slots)}</span><span class="spacer"></span><a class="link" href="#/shop/eggs">${free ? 'Buy eggs' : 'Eggs'}</a></div>${rows}`);
}

/** The Trainer tab's last card on computers and tablets: login streak, this region's Bestiary, Boss Ladder best. */
export function renderGlance() {
  const host = document.getElementById('glancesum');
  const t = S.trainer;
  if (!host) return;
  if (!t) { if (!host.hidden) { patch(host, ''); host.hidden = true; } return; }
  host.hidden = false;
  const region = GROUND[t.ground]?.region;
  const dex = region ? dexProgress(t.dex, t.dexClaimed, region) : null;
  const regionName = REGIONS.find((r) => r.id === region)?.name ?? '';
  const cell = (label: string, value: string, href: string, title: string) => `<a class="gl-cell" href="${href}" title="${esc(title)}"><b>${value}</b><span>${esc(label)}</span></a>`;
  patch(host, `<div class="gl-row">
    ${cell('day streak', full(t.daily.streak), '#/quests', 'Days in a row you claimed the daily reward')}
    ${dex ? cell(regionName, `${full(dex.caught)}<i>/${full(dex.total)}</i>`, '#/bestiary', `${regionName} Bestiary: species caught`) : ''}
    ${cell('ladder', t.ladder?.best ? `Step ${full(t.ladder.best)}` : '—', S.trailOn ? '#/trail' : '#/bosses', 'Highest Boss Ladder step you have cleared')}
  </div>`);
}
